import { SCHEDULING_KEYS } from '../../../../../global/constants/scheduler'

const schedulerFlow: Record<string, SCHEDULING_KEYS> = {
  [SCHEDULING_KEYS.customerInformation]: SCHEDULING_KEYS.chooseAService,
  [SCHEDULING_KEYS.chooseAService]: SCHEDULING_KEYS.appointmentSlot,
  [SCHEDULING_KEYS.appointmentSlot]: SCHEDULING_KEYS.paymentInformation,
  [SCHEDULING_KEYS.paymentInformation]: SCHEDULING_KEYS.confirmAppointment,
}

const finishFlow: Record<string, SCHEDULING_KEYS> = {
  [SCHEDULING_KEYS.customerInformation]: SCHEDULING_KEYS.chooseAService,
  [SCHEDULING_KEYS.chooseAService]: SCHEDULING_KEYS.appointmentSlot,
  [SCHEDULING_KEYS.appointmentSlot]: SCHEDULING_KEYS.paymentInformation,
  [SCHEDULING_KEYS.paymentInformation]: SCHEDULING_KEYS.confirmAppointment,
}

const customerSchedulerFlow: Record<string, SCHEDULING_KEYS> = {
  [SCHEDULING_KEYS.customerInformation]: SCHEDULING_KEYS.chooseAService,
  [SCHEDULING_KEYS.chooseAService]: SCHEDULING_KEYS.appointmentSlot,
  [SCHEDULING_KEYS.appointmentSlot]: SCHEDULING_KEYS.paymentInformation,
  [SCHEDULING_KEYS.paymentInformation]: SCHEDULING_KEYS.confirmAppointment,
  [SCHEDULING_KEYS.confirmAppointment]: SCHEDULING_KEYS.appointmentConfirmation, //the only difference from regular scheduler flow
}

const customerRescheduleFlow: Record<string, SCHEDULING_KEYS> = {
  [SCHEDULING_KEYS.appointmentSlot]: SCHEDULING_KEYS.appointmentConfirmation,
}

export {
  schedulerFlow,
  customerSchedulerFlow,
  customerRescheduleFlow,
  finishFlow,
}
